import React, {useContext, useEffect, useState} from 'react';
import style from './products.module.css'
import {Store} from "../../../Store";
import axios from "../../../API/api";
import pen from "../../../assets/tables/pen.svg";
import TableModal from "../Users/TableModal";
import trash from "../../../assets/tables/delete.svg";
import Table from "../Table";
import ProductsModal from "./ProductModal";
import trashDark from "../../../assets/tables/trashDark.svg";
import penDark from "../../../assets/tables/penDark.svg";
import {useTranslation} from "react-i18next";

export default function Products() {
   const {state, dispatch} = useContext(Store);
   const [mainData, setMainData] = useState([]);
   const {t} = useTranslation()

   useEffect(() => {
      axios.get(`/api/v1/product/categories`, {headers: {Authorization: `Bearer ${state.token}`}})
         .then((res) => {
            setMainData(res.data.data)
            dispatch({type: 'LOADER', payload: false})
         })
         .catch((err) => {
            console.log(err)

         })
   }, [state.updated])

   const columns = React.useMemo(
      () => [
         {
            Header: '№',
            accessor: "id",
            Width: 10,
            Cell: ({row}) => {
               return state.page*state.perPage +row.index+1
            }
         },
         {
            Header: t('Product names'),
            accessor: 'name',
            sortBy: true,
         },
         {
            Header: t('action'),
            accessor: 'action',
            Width: 150,
            Cell: (row) => {
               return <div className={style.TakeAction}>
                  {state.permissions.includes("PRODUCT_CATEGORY_UPDATE") ?
                     <ProductsModal img={state.mode === 'dark' ? pen : penDark} data={row.row.original} updated={true}
                                    title={t('Change category')} updatedUrl={'/api/v1/product/categories/update'} id={row.row.original.id}/> : ""}
                  {state.permissions.includes("PRODUCT_CATEGORY_DELETE") ?
                     <TableModal img={state.mode === 'dark' ? trash : trashDark} data={'delete'} title={t('Delete category')} deleteId={row.row.original.id}
                                 url={'/api/v1/product/categories'}/> : ""}
               </div>
            }
         },
      ],
      [],
   )

   const data = React.useMemo(
      () => mainData,
      [mainData]
   )

   return (
      <div className={style[state.mode]}>
         <div className={style.top}>
            <p>Категория</p>
            {state.permissions.includes("PRODUCT_CATEGORY_CREATE") ?
               <ProductsModal postUrl={'/api/v1/product/categories/create'} category={true}
                              title={t('Add category')}/> : ""}
         </div>
         <Table data={data} columns={columns}/>
      </div>
   )
}